/*
  Carousel Arrows - Wires [data-carousel-arrows] buttons to Splide API.

  Scope: walks up the DOM from each arrows container until it finds the
  nearest ancestor that contains a <splide-carousel>. That ancestor IS
  the local wrapper (e.g. .inline-cross-sell, .sibling-range,
  .cart-cross-sell, .collection-related). This is required because a
  single Shopify section can contain multiple carousels (PDP main-product
  section has both pdp-sibling-range and pdp-inline-cross-sell, plus
  potentially others). Using `section.querySelector('splide-carousel')`
  always returned the FIRST carousel in source order — so all arrows in
  the section controlled the same one.

  Handles AJAX-loaded sections (related-products) via MutationObserver.
*/
(function() {
  function findOwnSplide(container) {
    /* Walk up: parent → grandparent → ... and return the first ancestor
       that has a <splide-carousel> as a descendant. This locks each
       arrow group to the splide in its own wrapper. */
    var node = container.parentElement;
    while (node && node !== document.body) {
      var splide = node.querySelector('splide-carousel');
      if (splide) return splide;
      node = node.parentElement;
    }
    return null;
  }

  function initArrows(container) {
    var splideEl = findOwnSplide(container);
    var prevBtn = container.querySelector('[data-carousel-prev]');
    var nextBtn = container.querySelector('[data-carousel-next]');

    if (!splideEl || !prevBtn || !nextBtn) return;

    /* Hide any default Splide arrows that share a wrapper with this splide.
       Scoped to the splide's parent to avoid hiding sibling carousels' arrows. */
    var splideWrapper = splideEl.parentElement || splideEl;
    splideWrapper.classList.add('has-carousel-arrows');
    var defaultArrows = splideWrapper.querySelectorAll('.splide__arrows');
    defaultArrows.forEach(function(el) { el.style.display = 'none'; });

    /* Wait for Splide instance to be ready */
    var attempts = 0;
    function wire() {
      attempts++;
      if (splideEl.slideInstance) {
        var s = splideEl.slideInstance;

        function updateState() {
          var perPage = s.options.perPage || 1;
          prevBtn.disabled = s.index <= 0;
          nextBtn.disabled = s.index >= s.length - perPage;
        }

        prevBtn.addEventListener('click', function() { s.go('<'); });
        nextBtn.addEventListener('click', function() { s.go('>'); });
        s.on('moved', updateState);
        s.on('resized', updateState);
        s.on('refresh', updateState);
        updateState();
      } else if (attempts < 100) {
        requestAnimationFrame(wire);
      }
    }
    requestAnimationFrame(wire);
  }

  function initAll() {
    document.querySelectorAll('[data-carousel-arrows]:not([data-arrows-init])').forEach(function(el) {
      el.setAttribute('data-arrows-init', '');
      initArrows(el);
    });
  }

  /* Init on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when DOM changes (AJAX sections like related-products) */
  if (typeof MutationObserver !== 'undefined') {
    var debounce;
    new MutationObserver(function() {
      clearTimeout(debounce);
      debounce = setTimeout(initAll, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
